<template>
  <div>
    <breadcrumb :routerList="[{to:'/agent/agentCopy',title:'经销商管理'},{title:'经销商解冻审批'}]"/>
    <div class="h-content">
      <div class="h-row h-mrt0">
        <div class="h-rowIn">
          <div class="h-rowBox">
            <div class="h-rowCon">
              <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                  <h1>基本信息</h1>
                </div>
                <div class="h-pieceCon2" style="padding:0">
                  <div class="h-formLine">
                    <div class="tanBox">
                      <el-table
                              :data="tableData"
                              ref="multipleTable"
                              :border="true"
                              style="width: 100%"
                              max-height="450"
                      >
                        <el-table-column
                                label="合同编号"
                                prop="ccode"
                                width="120"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                label="合同名称"
                                prop="contractName"
                                width="120"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                label="供应商编码"
                                prop="customerCode"
                                width="100"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                label="供应商名称"
                                prop="customerName"
                                width="200"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                label="产品编码"
                                prop="productId"
                                width="100"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                label="产品名称"
                                prop="productName"
                                width="140"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                label="税率"
                                prop="shuilv"
                                width="60"
                                show-overflow-tooltip>
                          <template slot-scope="scope">
                            <dictname category="cgshuilv"  :v="scope.row.shuilv"/>
                          </template>
                        </el-table-column>
                        <el-table-column
                                label="原价格"
                                prop="oldUnitPrice"
                                width="100"
                                show-overflow-tooltip>
                          <template slot-scope="scope">
                            {{ cleanNumber(scope.row.oldUnitPrice).toString() }}
                          </template>
                        </el-table-column>
                        <el-table-column
                                label="调整后价格"
                                prop="unitPrice"
                                width="100"
                                show-overflow-tooltip>
                          <template slot-scope="scope">
                            {{ cleanNumber(scope.row.unitPrice).toString() }}
                          </template>
                        </el-table-column>
                        <el-table-column
                                label="价差"
                                prop="priceSpread"
                                width="100"
                                show-overflow-tooltip>
                          <template slot-scope="scope">
                            {{ calculatePriceDiff(scope.row.unitPrice, scope.row.oldUnitPrice) }}
                          </template>
                        </el-table-column>
                        <el-table-column
                                label="备注"
                                prop="bz"
                                width="130"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                label="调价人"
                                prop="cuname"
                                width="70"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                label="调价时间"
                                prop="cdate"
                                width="140"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                label="审核通过时间"
                                prop="approvalTime"
                                width="140"
                                show-overflow-tooltip>
                        </el-table-column>
                        <!--<el-table-column
                                fixed="right"
                                label="操作"
                                width="150" >
                          <template slot-scope="scope">
                            <div style="text-align: left;">
                              <el-button
                                      v-if="null != scope.row.instId && '' != scope.row.instId"
                                      type="text"
                                      size="small"
                                      class="h-tableLink h-btn"
                                      @click="genzongLiuch(scope.row)">
                                跟踪
                              </el-button>
                              <el-button
                                      type="text"
                                      size="small"
                                      @click="beian(scope.row)"
                                      class="h-tableLink h-btn">
                                备案
                              </el-button>
                            </div>
                          </template>
                        </el-table-column>-->
                      </el-table>
                    </div>
                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                      <h1>附件</h1>
                    </div>
                    <div label="采购调价记录备案附件" class="h-elformWrap-2" style="margin-left:0.5rem;">
                      <brupload
                              :refid="refid"
                              reftype="采购调价记录备案"
                              :uploadflag="false"
                              delflag
                              :tpFlag="true"
                              :showtime="false"
                      >
                      </brupload>
                    </div>
                  </div>
                  <div class="bannerBox2">
                    <div class="h-row h-mrt1">
                      <div class="h-rowIn">
                        <div class="h-rowBox">
                          <div class="h-rowCon">
                            <div class="h-pieceIn2">
                              <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                              <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                <h1>审核信息</h1>
                              </div>
                              <div class="h-pieceCon2 ">
                                <div class="h-formLine weekplandetail11" style="position: relative;">
                                  <el-form :inline="true" :model="beianData">
                                    <el-form-item label="审批意见" class="h-elformWrap-2 newBox"
                                                  style="width: 100%!important;">
                                      <el-input
                                              v-model="beianData.auditMind2"
                                              placeholder="请输入"></el-input>
                                    </el-form-item>
                                  </el-form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="text-align: center;margin-top: 0.3rem">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="goBack"> 返回 </el-button>

                    <el-button class="h-btn h-bBtn h-bgred" @click="pass(2)">驳回</el-button>
                    <el-button class="h-btn h-bBtn h-bggreen" @click="pass(1)">通过</el-button>

                    <el-button class="h-btn h-bBtn" @click="viewpress">
                      审批跟踪
                    </el-button>
                  </div>
                  <viewhistory :visible.sync="showhistory" v-if="showhistory"
                               :id="instid"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import reduceCost from "@/api/invoice/reduceCost";
  import agentCopyService from "../../api/loud/agent/agentCopyService";
  export default {
    data(){
      return {
        valueTime: 0,
        beianflag:false,
        showhistory:false,
        instid:null,
        refid:null,
        tableData: [],
        beianData:{},
      }
    },
    filters: {
    },
    methods: {

      // 清洗单个数值：统一格式为“最多2位小数，无小数显整数”
      cleanNumber(value) {
        // 步骤1：处理空值/非数值（如null/undefined/""，默认按0处理）
        if (value === null || value === undefined || value === "") {
          return 0;
        }
        // 步骤2：转为数字类型（处理字符串格式的数值，如"10.00"→10.00）
        const num = Number(value);
        // 步骤3：确保是有效数字（避免NaN，无效数字按0处理）
        if (isNaN(num)) {
          return 0;
        }
        // 步骤4：保留2位小数→转数字（去末尾0）→返回处理后的值（数字类型）
        return Number(num.toFixed(2));
      },

      // 计算价格差值并格式化最终结果
      calculatePriceDiff(unitPrice, oldUnitPrice) {
        // 步骤1：分别清洗两个参数（确保格式统一）
        const cleanedUnitPrice = this.cleanNumber(unitPrice);
        const cleanedOldUnitPrice = this.cleanNumber(oldUnitPrice);

        // 步骤2：计算差值（处理浮点数精度问题）
        const diff = (cleanedUnitPrice * 100 - cleanedOldUnitPrice * 100) / 100;

        // 步骤3：格式化差值（最多2位小数，不补0）
        return Number(diff.toFixed(2)).toString();
      },
      changeTime(date){
        if(date){
          this.formInline.cdateStart = date[0];
          this.formInline.cdateEnd = date[1];
        }else{
          this.formInline.cdateStart = '';
          this.formInline.cdateEnd = '';
        }
      },

      choseSelected(){
      },

      viewpress() {
        this.showhistory = true;
      },
      goBack() {
        this.$router.push({
          path: '/agent/agentCopy'
        })
      },
      query(){
        let query = {
          instid:this.$route.query.instid,
        }
        reduceCost.selectListByInstid(query).then(res => {
          this.tableData = res.msg;
          this.refid =  this.tableData[0].refid;
        })
      },
      pass(aaa){
        let query = {
          taskid:this.$route.query.taskid,
          aaa:aaa,
          id:this.$route.query.ywid,
          auditMind2:this.beianData.auditMind2,
          instid:this.$route.query.instid,
          ywid:this.$route.query.ywid,
        }
        reduceCost.cgBeiAnShenpiPass(query).then(res => {
          this.$msg.alerts("提交成功！", () => {
            //刷新右上角的代办个数
            this.$store.dispatch("searchTasktotal")
            //跳转回系统的代办列表
            this.$router.push({
              path: '/personal/dealCenter'
            })
          })
        })
      }

    },
    created(){
      this.taskid =  this.$route.query.taskid;
      this.instid =  this.$route.query.instid;
      this.query();
    },
    computed: {
    },
  }
</script>

<style>
  .xuanzewuliao .el-dialog__header{
    padding-top: 20px;
    padding-left: 20px;
  }
  .xuanzewuliao .el-dialog__body{
    padding: 20px;
  }
  .xuanzewuliao .el-table tbody td .cell {
    padding: 0.1rem 0.1rem !important;
  }
  .xuanzewuliao .h-formbLine .el-form-item__label{
    width: 39%;
  }
  .xuanzewuliao  .h-formbLine .el-form-item__content{
    width: 55%;
  }
  .xuanzewuliao .yxline .h-formbLine .el-form-item__content{
    width: 55%;
  }
  .xuanzewuliao .yxline{
    padding-top: 0;
  }
  .xuanzewuliao .h-pagination{
    padding-top: 0rem;
    padding-bottom: 0rem;
  }
  .xuanzewuliao .h-rowCon{
    padding-bottom: 0rem;
  }
</style>
